module.exports = __webpack_public_path__ + "static/media/exit.ad9884a5.svg";